import Countdown from 'react-countdown';
import { useNavigate } from 'react-router';
import { Trans, useTranslation } from 'react-i18next';
import {
  Typography,
  ProfileView,
  HeaderLayout,
  IHeaderLayout,
  LanguageDropdown,
  NotificationView,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import { SubscriptionTypesEnum, getTrialCountdownText } from '@thinknet-gmbh/platform-common';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { useChangeLanguage } from 'src/hooks/members/change-language.hook';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { useGetCurrentSubscription } from 'src/hooks/subscriptions/get-current-subscription.hook';
import { useGetNotifications } from 'src/hooks/notifications/get-notifications.hook';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import { TrialPeriodWrapper } from './header.styles';

export const Header = (headerProps: IHeaderLayout) => {
  const { i18n, t } = useTranslation('common');
  const navigate = useNavigate();
  const changeLanguage = useChangeLanguage();
  const { account, profile, loading } = useGetCurrentAccount();
  const { subscription } = useGetCurrentSubscription();
  const { subscriptionType, trialEndAt } = subscription;

  const { notifications, unreadCount } = useGetNotifications({
    pageSize: 5,
    skipPopupNotifications: false,
  });

  const screens = useBreakpoint();

  return (
    <HeaderLayout {...headerProps}>
      {!loading && (
        <>
          {subscriptionType === SubscriptionTypesEnum.TRIAL && (
            <TrialPeriodWrapper>
              <Typography weight="bold">
                {t(`${screens.md ? 'labels.trialPeriod' : 'labels.trialPeriodShort'}`)}:
              </Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                <Countdown
                  date={trialEndAt}
                  intervalDelay={60 * 1000}
                  renderer={props => getTrialCountdownText({ t, ...props })}
                />
              </Typography>
            </TrialPeriodWrapper>
          )}

          <LanguageDropdown
            language={i18n.language}
            onChange={language => {
              changeLanguage({ variables: { language } });
            }}
          />
          <NotificationView
            data={notifications.map((notification: any) => {
              const variablesKeys = Object.keys(notification.translationVariables);
              const values = variablesKeys.reduce((result, key) => {
                return Object.assign(result, {
                  [key]: notification.translationVariables[key]
                    ? notification.translationVariables[key]
                    : i18n.t('notifications:titles.deleted'),
                });
              }, {});

              return (
                <div style={{ opacity: notification.isReadByAccount ? 0.5 : 1 }}>
                  <Trans
                    i18nKey={notification.translationPath}
                    values={values}
                    components={{
                      target: <span style={{ color: PLATFORM_THEME_COLORS.primary.blue }} />,
                    }}
                  />
                </div>
              );
            })}
            count={unreadCount}
            onClickHandler={() => navigate(ROUTES.notifications)}
          />
          <ProfileView
            avatar={profile.avatarUrl}
            name={profile.displayName}
            description={account.permissionGroup}
            onClick={() => navigate(ROUTES.userProfile)}
          />
        </>
      )}
    </HeaderLayout>
  );
};

export default Header;
